/**
 * Masters Feature Routes
 * Routes for the master tag import management page.
 */

import permissions from '@Share/config/permissions';

export default [
  {
    path: '/manage-masters',
    name: 'MastersAdmin',
    component: () => import('./views/Masters.vue'),
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Masters Management',
      permissions: [permissions.Tags.Masters.View],
    },
  },
];
